import React from 'react';
import orderStatusThemeStyle from './orderStatusThemeStyle';
import { OrderStatusType } from '../../../types/order/orderType';

export default function ({ status }: { status: OrderStatusType }) {
  const statusTagStyle = orderStatusThemeStyle(status);
  return (
    <small
      className={`${statusTagStyle} font-medium rounded-3xl block w-fit px-2 py-1 capitalize`}
    >
      {status.replaceAll('_', ' ')}
    </small>
  );
}
